import React, { Component } from 'react';
import './FullScreenSlider.css';

class FullScreenSlider extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
        data: null,
        interval: null,
        actualIndex: 0
    };

    this.timeout = this.props.timeout ? this.props.timeout : 5000;

    // bind methods
    this.updateSlider = this.updateSlider.bind(this);
  }

  loadData(){

    var jsonData = document.getElementById('data-slider');

    if(jsonData){

      var parsedData = JSON.parse(jsonData.innerHTML);

      if(parsedData.length > 1){

        this.setState({
          interval: setInterval(this.updateSlider, this.timeout)
        });

      }

      this.setState( {data: parsedData } );
    }

  
  }

  updateSlider(){
    this.setState({
      actualIndex: ( this.state.actualIndex + 1 ) < this.state.data.length ? this.state.actualIndex + 1 : 0
    });
  }

  componentWillMount(){
    this.loadData();
  }

  componentDidMount() {
  }

  render() {

    if(!this.state.data){

      return (
          <span>Missing data</span>
        );
    }

    var style = {
      backgroundImage: 'url(' + this.state.data[this.state.actualIndex].src + ')'
    };

    return (
      <div className="FullScreenSlider">
        <div style={style}></div>
      </div>
    );

  }
}

export default FullScreenSlider;



// WEBPACK FOOTER //
// ./src/FullScreenSlider.js